import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuModel } from '../../models/common/menu.model';
import { Router, RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SidebarService } from '../../services/sidebar.service';
import { MapService } from '../../services/map.service';
import { MapInfo } from '../../models/mapinfo.model';
import { ProcessLoadingService } from '../../services/loading.service';
import { TagsService } from '../../services/tags.service';
import { DialogErrorService } from '../../services/dialog-error.service';
import { ROUTE_PATH } from '../../constants/route-path';
import { TEXT_COMMON } from '../../constants/text';


@Component({
  selector: 'careposi-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, AngularSvgIconModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {
  @Input() isExpanded: boolean = false;
  @Input() data: MenuModel[] = [];
  @Output() toggleSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() toggleSidebarConplete: EventEmitter<boolean> = new EventEmitter<boolean>();
  openedMenuTitles: string[] = [];
  activeMenuTitle: string | null = null;
  lstMapManager: MapInfo[] = [];
  readonly TEXT_COMMON = TEXT_COMMON;
  constructor(
    private sidebarService: SidebarService,
    private mapService: MapService,
    private loadingService: ProcessLoadingService,
    private router: Router,
    private tagsService: TagsService,
    private dialogErrorService: DialogErrorService,
  ) {


  }

  async ngOnInit(): Promise<void> {
    try {
      const tags = await this.tagsService.getListTag();
      if (!tags) {
        this.dialogErrorService.showDialogError(TEXT_COMMON.ERROR_OTHER);
      }
    } catch {
      this.dialogErrorService.showDialogError(TEXT_COMMON.ERROR_OTHER);
    }
  }

  showPendingTagMarker(menu: MenuModel): boolean {
    if (!this.tagsService.hasUnappliedTags) return false;
    if (menu.path === `${ROUTE_PATH.SETTINGS}/${ROUTE_PATH.TAGREGISTRATION}`) {
      return true;
    }
    return menu.path === ROUTE_PATH.SETTINGS
      && !!menu.children?.some(child => child.path === `${ROUTE_PATH.SETTINGS}/${ROUTE_PATH.TAGREGISTRATION}`)
      && (!this.isExpanded || !this.openedMenuTitles.includes(menu.title ?? ''));
  }
  onShowNotify(event: MouseEvent) {
    event.stopPropagation();

  }

  onLogout() {

  }
  onProfile() {

  }
  timeoutComplete:any = null;
  handleSidebarToggle(event: any) {
    //this.hiddenTotal = !this.hiddenTotal;
    if (this.isExpanded) {
      this.openedMenuTitles = []; // <-- Collapse all parents
    }
    if( this.timeoutComplete)  clearTimeout(this.timeoutComplete);
    this.timeoutComplete = setTimeout(() => {
      this.toggleSidebarConplete.emit();
      this.sidebarService.onToggleConplete();
    }, 400);
    this.toggleSidebar.emit(!this.isExpanded);
    //this.sidebarExpandHandleService.newEvent(!this.isExpanded);
  }
  canAccess = (item: MenuModel) => {
    // let path = item.path ?? (item.children && item.children[0].path.split('/').shift());
    // return path && this.currentPermission.some((x: string) => this.permissionMap['/' + path]?.read.includes(x));
    return true;
  }
  hasChild(menu: MenuModel) {
    return !!menu.children && menu.children.length > 0;
  }

  isMenuActive(menu: MenuModel): boolean {
    if (!menu) {
      return false;
    }
    const currentUrl = this.router.url.split('?')[0].split('#')[0];

    // Always check own path first — handles L2 menus that have both a path AND children
    if (menu.path && this.isPathMatch(currentUrl, menu.path)) {
      return true;
    }

    // Then recursively check children (handles L1 active when L2/L3 is active)
    if (this.hasChild(menu)) {
      return menu.children?.some((child) => this.isMenuActive(child)) ?? false;
    }

    return false;
  }

  /** True only when the URL exactly matches this menu's own path (not a deeper child). */
  private isMenuSelfActive(menu: MenuModel): boolean {
    const currentUrl = this.router.url.split('?')[0].split('#')[0];
    return this.isPathMatch(currentUrl, menu.path);
  }

  private isPathMatch(url: string, path?: string): boolean {
    if (!path) {
      return false;
    }
    const normalized = path.startsWith('/') ? path : `/${path}`;
    return url === normalized || url.startsWith(`${normalized}/`);
  }

  expandCollapseChild(event: MouseEvent, menu: MenuModel) {
    event.preventDefault();
    event.stopPropagation();
      // If the sidebar is collapsed, expand it
    if (!this.isExpanded) {
      this.toggleSidebar.emit(true); // request expand
      // Optional: wait for sidebar animation to finish
      setTimeout(() => {
        this.toggleMenu(menu);
      }, 200); // adjust timing if you have a sidebar animation
    } else {
      this.toggleMenu(menu);
    }
  }
  /**
   * Level 2 click handler:
   * - If L2 is SELF-active (URL matches L2 own path) → toggle collapse/expand only (no redirect)
   * - Otherwise (not active, or a child/grandchild is active) → navigate to L2 route
   */
  handleChildToggle(event: MouseEvent, parentMenu: MenuModel, menu: MenuModel) {
    event.preventDefault();
    event.stopPropagation();

    if (this.isMenuSelfActive(menu)) {
      // If grandchild is active, redirec to child
      const isGrandchildActive = menu.children?.some((child) => this.isMenuActive(child)) ?? false;
      if(isGrandchildActive) {
        if(menu.path) this.router.navigate([menu.path]);
      } else {
        this.toggleMenu(menu);
      }
      return;
    }

    // Case 1 & 4: not at L2 self (or currently at L3) → navigate to L2
    if (menu.path) {
      this.router.navigate([menu.path]);
    }

    // Ensure Level-1 parent is open
    if (parentMenu.title && !this.openedMenuTitles.includes(parentMenu.title)) {
      this.openedMenuTitles.push(parentMenu.title);
    }

    // Ensure Level-2 is expanded
    if (menu.title && !this.openedMenuTitles.includes(menu.title)) {
      this.openedMenuTitles.push(menu.title);
    }
  }

  /**
   * Level 3 click handler:
   * - Navigate to L3 route
   * - Ensure both L1 (grandParent) and L2 (parent) are marked open/active
   */
  onChildClick(parentMenu: MenuModel, child: MenuModel) {
    // Ensure the clicked item's parent chain is open in the menu tree
    if (parentMenu.title && !this.openedMenuTitles.includes(parentMenu.title)) {
      this.openedMenuTitles.push(parentMenu.title);
    }
  }

  /**
   * Level 3 (grandchild) click handler:
   * Ensures both L1 grandParent and L2 parent are open so the active
   * state propagates correctly up the ancestry chain.
   */
  onGrandChildClick(grandParentMenu: MenuModel, parentMenu: MenuModel, child: MenuModel) {
    if (grandParentMenu.title && !this.openedMenuTitles.includes(grandParentMenu.title)) {
      this.openedMenuTitles.push(grandParentMenu.title);
    }
    if (parentMenu.title && !this.openedMenuTitles.includes(parentMenu.title)) {
      this.openedMenuTitles.push(parentMenu.title);
    }
  }

  toggleMenu(menu: MenuModel) {
    const idx = this.openedMenuTitles.indexOf(menu.title as string);
    if (idx > -1) {
      // Remove parent from opened list (collapse)
      this.openedMenuTitles.splice(idx, 1);
    } else {
      // Add parent to opened list (expand)
      this.openedMenuTitles.push(menu.title as string);
    }
  }
}
